import { Component } from '@angular/core';

@Component({
  selector: 'caption-label',
  template: '<p class="CaptionLabel"><ng-content></ng-content></p>',
  styleUrls: ['./caption-label.component.scss'],
})
export class CaptionLabelComponent {}
